import StickySidebar from "sticky-sidebar";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".sticky-block")) {
    const windowHeight = window.innerHeight;
    const sidebarHeight = document.querySelector(".sticky-block").offsetHeight;
    const headerHeight = document.querySelector(".header").offsetHeight;

    if(windowHeight > sidebarHeight + headerHeight && window.innerWidth > 787) {
      const sidebar = new StickySidebar(".sticky-block", { topSpacing: 200 });
    }
    
  }
});
